import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { classNames } from "primereact/utils";
import { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { FormInputFile } from "../../components/FormInputFile";
import FormNumberInput from "../../components/FormNumberInput";
import { FormTextarea } from "../../components/FormTextarea";
import ImagePDFComponent from "../../components/ImagePDFComponent";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { AlertService } from "../../utility/service/alert-service";
import { downloadMultipartFile } from "../../utility/service/api-file";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { getCompanyPlaceList } from "../../utility/service/carbon-service";
import {
  F1050312Before,
  createFootprintItem,
  queryCarbonFootprintDetail,
  queryCompanyProduct,
  queryCompanyProductDetail,
  queryPcrReportList,
  updateFootprintItem,
} from "../../utility/service/carbonFootprint-service";
import {
  Base64Encoder,
  BcryptEncoder,
  checkDpSuccess,
  getFileBase64,
  getFormErrorMessage,
  setformate,
  splitFileExtension,
  splitFileName,
} from "../../utility/service/tool-service";
import { addFormValidator } from "../../utility/validate/formValidator";

const InventoryCarbonFootprintCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { itemObj, setItemObj, action, setAction, currentComSeq, companyName } = useOutletContext();
  const [unitCodeList, setUnitCodeList] = useState([]);
  const [lifeCycleScopeList, setLifeCycleScopeList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [comProductList, setComProductList] = useState([]);
  const [formRule, setFormRule] = useState([]); //表單驗證
  const [pcrReportList, setPcrReportList] = useState([]);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [, loading] = useContext(SystemLoading);
  // 產品圖片
  const [previewUrl, setPreviewUrl] = useState(null);
  const [zoomSrc, setZoomSrc] = useState(null);
  const [fileInfo, setFileInfo] = useState({});
  // 產品製作流程圖
  const [flowFileInfo, setFlowFileInfo] = useState({});
  const [flowPreviewUrl, setFlowPreviewUrl] = useState(null);
  const [flowZoomSrc, setFlowZoomSrc] = useState(null);
  // PCR檔案
  const pcrFileInputRef = useRef();
  const [pcrFileInfo, setPcrFileInfo] = useState({});
  const [pcrPreviewUrl, setPcrPreviewUrl] = useState(null);
  const [pcrZoomSrc, setPcrZoomSrc] = useState(null);
  const [currentObj, setCurrentObj] = useState({});
  const isEditable = useEditableFlag("F10503"); // control edit by F10503
  const [placesList, setPlacesList] = useState([]);
  const [companyPlaceList, setCompanyPlaceList] = useState([]);

  const {
    register,
    handleSubmit,
    watch,
    clearErrors,
    getValues,
    setValue,
    resetField,
    reset: resetForm,
    control,
    trigger,
    reset,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {
      layoutPic: "",
      sensitivityDeltaPct: "",
      sensitivityReason: "",
    },
    //錯誤驗證時機
    mode: "all",
  });

  useEffect(() => {
    if (action === "") {
      btnBackTo();
    }
  }, [action]);

  // 設置標記，表示從子頁面返回
  useEffect(() => {
    sessionStorage.setItem("fromInventoryCarbonFootprintChildPage", "true");
  }, []);

  const btnBackTo = () => {
    navigate("/management/inventoryCarbonFootprint");
  };

  const inputCheckKeyDown = (e) => {
    //避免觸發 按enter 後 就觸發 onSubmit 事件冒泡 給input 使用 <FormInput enterClick事件 ; 一般input onKeyDown事件
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  useLayoutEffect(() => {
    axios_getCompanyPlaceList();
    axios_CoefficientUnitList();
    // 使用選中的組織，如果沒有則使用使用者的組織
    if (currentComSeq !== "") {
      axios_queryCompanyProduct({ companySeq: currentComSeq });
    }
    axios_getCreateBefore();
  }, [currentComSeq]);

  //建立前查詢form 規則
  const axios_getCreateBefore = () => {
    F1050312Before().then((res) => {
      if (checkDpSuccess(res)) {
        let array = [];
        res?.data?.RespBody?.constraints?.forEach((item) => {
          const result = addFormValidator(item?.field, res.data.RespBody.constraints);
          array.push(result);
        });
        setFormRule(array);
      }
    });
  };
  const setValidForm = useCallback(
    (formId) => {
      if (formRule?.length > 0) {
        const tmp = formRule?.find((item) => {
          return Object.keys(item)[0] === formId;
        });
        return tmp ? tmp[formId] : "";
      }
    },
    [formRule]
  );

  //組織邊界廠商清單
  const axios_getCompanyPlaceList = () => {
    setIsLoading(true);
    getCompanyPlaceList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.companyPlaceList;
          setCompanyPlaceList(data);

          const currentCompanySeq = currentComSeq;
          const currentPlaces = data?.find((item) => item.companySeq === currentCompanySeq)?.placeList || [];
          setPlacesList(currentPlaces);
        }
      })
      .finally((fin) => {
        setIsLoading(false);
      });
  };

  const axios_queryCompanyProduct = (reqBody) => {
    queryCompanyProduct(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res?.data?.RespBody?.evaluationTemplates?.options;
        setComProductList(data);
      }
    });
  };

  const axios_queryCompanyProductDetail = (reqBody) => {
    queryCompanyProductDetail(reqBody).then((res) => {
      if (checkDpSuccess(res)) {
        let resData = res?.data?.RespBody;

        setValue("productEName", resData?.productEName);
        setValue("productType", resData?.productType);
        setValue("technicalDescription", resData?.technicalDescription);
        setValue("declaringUnit", resData?.declaringUnit);
        setValue("functionalUnit", resData?.functionalUnit);
        setValue("productIntroduction", resData?.productIntroduction);
        if (resData?.fileExtension !== null) {
          setZoomSrc(resData?.filePath); //原圖
          if (resData?.fileExtension === "pdf") {
            setPreviewUrl(resData?.filePath); //原圖
          } else {
            setPreviewUrl(resData?.filePathSml); //縮圖
          }
          setFileInfo({
            type: resData?.fileExtension,
            name: `${resData?.fileName}.${resData?.fileExtension}`,
          });
        } else {
          setZoomSrc("");
          setPreviewUrl("");
          setFileInfo({});
        }
        if (resData?.flowFileExtension !== null) {
          setFlowZoomSrc(resData?.flowFilePath); //原圖
          if (resData?.flowFileExtension === "pdf") {
            setFlowPreviewUrl(resData?.flowFilePath); //原圖
          } else {
            setFlowPreviewUrl(resData?.flowFilePathSml); //縮圖
          }
          setFlowFileInfo({
            type: resData?.flowFileExtension,
            name: `${resData?.flowFileName}.${resData?.flowFileExtension}`,
          });
        } else {
          setFlowZoomSrc("");
          setFlowPreviewUrl("");
          setFlowFileInfo({});
        }
      }
    });
  };

  const axios_queryCarbonFootprintDetail = (carbonFpId) => {
    queryCarbonFootprintDetail({ carbonFpId }).then((res) => {
      if (checkDpSuccess(res)) {
        let resData = res?.data?.RespBody;
        setCurrentObj(resData);
        setValue("offeringsId", resData?.offeringsId);
        setValue("productEName", resData?.productEName);
        setValue("productType", resData?.productType);
        setValue("declaringUnit", resData?.declaringUnit);
        setValue("functionalUnit", resData?.functionalUnit);
        setValue("technicalDescription", resData?.technicalDescription);
        setValue("productIntroduction", resData?.productIntroduction);
        setValue("inspectionStartDate", new Date(resData?.inspectionStartDate), { shouldValidate: true });
        setValue("inspectionEndDate", new Date(resData?.inspectionEndDate), { shouldValidate: true });

        setValue("lifeCycleScope", resData?.lifeCycleScope);
        setValue("quantity", resData?.quantity);
        setValue("unitWeightKg", resData?.unitWeightKg);
        setValue("productRatio", resData?.productRatio);
        setValue("productRatioComment", resData?.productRatioComment);
        setValue("distributionPrinciple", resData?.distributionPrinciple);
        setValue("excludedItems", resData?.excludedItems);
        setValue("pcrReportId", resData?.pcrReportId);
        setValue("sensitivityDeltaPct", resData?.sensitivityDeltaPct);
        setValue("sensitivityReason", resData?.sensitivityReason);
        // gwpSource
        setValue("coefSource", resData?.coefSource);
        setValue("consultingAgencyName", resData?.consultingAgencyName);
        setValue("implementingOrganization", resData?.implementingOrganization);
        setValue("verified", resData?.verified === "Y");
        setValue("verificationAgency", resData?.verificationAgency);
        setValue("comment", resData?.comment);
        setValue("placesList", resData?.placeSeq ? resData.placeSeq : []);
        // 產品圖
        if (resData?.fileExtension !== null) {
          setZoomSrc(resData?.filePath); //原圖
          if (resData?.fileExtension === "pdf") {
            setPreviewUrl(resData?.filePath); //原圖
          } else {
            setPreviewUrl(resData?.filePathSml); //縮圖
          }
          setFileInfo({
            type: resData?.fileExtension,
            name: `${resData?.fileName}.${resData?.fileExtension}`,
          });
        } else {
          setZoomSrc("");
          setPreviewUrl("");
          setFileInfo({});
        }
        // 產品製作流程圖
        if (resData?.flowFileExtension !== null) {
          setFlowZoomSrc(resData?.flowFilePath); //原圖
          if (resData?.flowFileExtension === "pdf") {
            setFlowPreviewUrl(resData?.flowFilePath); //原圖
          } else {
            setFlowPreviewUrl(resData?.flowFilePathSml); //縮圖
          }
          setFlowFileInfo({
            type: resData?.flowFileExtension,
            name: `${resData?.flowFileName}.${resData?.flowFileExtension}`,
          });
        } else {
          setFlowZoomSrc("");
          setFlowPreviewUrl("");
          setFlowFileInfo({});
        }
        // PCR 檔案
        if (resData?.pcrFileId !== null) {
          setPcrPreviewUrl(resData?.pcrFilePath); //原圖
          setPcrFileInfo({
            type: resData?.pcrFileExtension,
            name: `${resData?.pcrFileName}.${resData?.pcrFileExtension}`,
          });
          setValue("pcrFileId", resData?.pcrFileId);
          // setValue("pcrFilePic",resData?.pcrFilePic);
          setValue("pcrFileName", resData?.pcrFileName);
          setValue("pcrFileExtension", resData?.pcrFileExtension);

          downloadMultipartFile({
            fileId: resData?.pcrFileId,
          }).then((res) => {
            if (res) {
              const binaryData = res.data;
              const blob = new Blob([binaryData], { type: "application/octet-stream" });
              const file = new File([blob], `${resData?.pcrFileName}.${resData?.pcrFileExtension}`, {
                type: blob.type,
              });
              setValue("pcrFilePic", file);
            }
          });
        } else {
          setPcrZoomSrc("");
          setPcrPreviewUrl("");
          setPcrFileInfo({});
        }
      }
    });
  };

  useEffect(() => {
    if (JSON.stringify(itemObj) !== "{}") {
      axios_queryCarbonFootprintDetail(itemObj?.carbonFpId);
    }
  }, [itemObj]);

  const findLifeCycleScopeIndex = (array, code) => {
    let result = array?.filter((item) => item.subitemNo === code);
    return result.length > 0 ? result[0].index : false;
  };

  const onSubmit = (data) => {
    checkLoading(loading);
    let formData = new FormData();
    formData.append("companySeq", currentComSeq);
    if (data.offeringsId) formData.append("offeringsId", data.offeringsId);
    if (data.inspectionStartDate)
      formData.append("inspectionStartDate", setformate(data.inspectionStartDate, "YYYY/MM/DD"));
    if (data.inspectionEndDate) formData.append("inspectionEndDate", setformate(data.inspectionEndDate, "YYYY/MM/DD"));
    if (data.quantity) formData.append("quantity", data.quantity);
    if (data.unitWeightKg) formData.append("unitWeightKg", data.unitWeightKg);
    if (data.productRatio) formData.append("productRatio", data.productRatio);
    if (data.productRatioComment) formData.append("productRatioComment", data.productRatioComment);
    if (data.distributionPrinciple) formData.append("distributionPrinciple", data.distributionPrinciple);
    if (data.excludedItems) formData.append("excludedItems", data.excludedItems);
    if (data.pcrReportId) formData.append("pcrReportId", data.pcrReportId);
    if (data.sensitivityDeltaPct) formData.append("sensitivityDeltaPct", data.sensitivityDeltaPct);
    if (data.sensitivityReason) formData.append("sensitivityReason", data.sensitivityReason);
    if (data.gwpSource) formData.append("gwpSource", data.gwpSource);
    if (data.coefSource) formData.append("coefSource", data.coefSource);
    if (data.consultingAgencyName) formData.append("consultingAgencyName", data.consultingAgencyName);
    if (data.implementingOrganization) formData.append("implementingOrganization", data.implementingOrganization);
    formData.append("verified", data.verified ? "Y" : "N");
    if (data.verificationAgency) formData.append("verificationAgency", data.verificationAgency);
    if (data.comment) formData.append("comment", data.comment);
    if (data.placesList) formData.append("placeSeq", data.placesList.join("|"));
    if (data?.lifeCycleScope) {
      formData.append(
        "lifeCycleScope",
        Base64Encoder(BcryptEncoder(data.lifeCycleScope)) +
          "," +
          findLifeCycleScopeIndex(lifeCycleScopeList, data.lifeCycleScope)
      );
    }
    let pcrFileExtension =
      getValues("pcrFileExtension") !== undefined && getValues("pcrFileExtension") !== ""
        ? getValues("pcrFileExtension")
        : null;
    let pcrFileName =
      getValues("pcrFileName") !== undefined && getValues("pcrFileName") !== "" ? getValues("pcrFileName") : null;
    let pcrFilePic =
      getValues("pcrFilePic") !== undefined && getValues("pcrFilePic") !== "" ? getValues("pcrFilePic") : null;
    //有fileId 但沒有圖片表示要刪除 只傳 fileId 給後端 (刪除圖片)
    if (currentObj?.pcrFileId && pcrFilePic === null) {
      formData.append("pcrFileId", data?.pcrFileId);
      // console.log("刪除圖片");
    } else if (currentObj?.pcrFileId == null && pcrFilePic !== null) {
      //如果沒有fileId 但有file 表示要新增file
      formData.append("pcrFilePic", pcrFilePic);
      formData.append("pcrFileName", pcrFileName);
      formData.append("pcrFileExtension", pcrFileExtension);
      // console.log("新增file");
    } else if (pcrFilePic !== null && currentObj?.pcrFileName !== pcrFileName && currentObj?.pcrFileId !== null) {
      //如果有圖片 但是檔名不同表示要更新圖片
      formData.append("pcrFileId", data?.pcrFileId);
      formData.append("pcrFilePic", pcrFilePic);
      formData.append("pcrFileName", pcrFileName);
      formData.append("pcrFileExtension", pcrFileExtension);
      // console.log("更新file");
    }

    if (action === "create") {
      createFootprintItem(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t("button.create") + " " + t("message.success"));
            btnBackTo();
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    } else {
      formData.append("carbonFpId", itemObj?.carbonFpId);
      updateFootprintItem(formData)
        .then((res) => {
          if (checkDpSuccess(res)) {
            handleSuccessMessage(dispatch, t("button.update") + " " + t("message.success"));
            btnBackTo();
          }
        })
        .finally((fin) => {
          checkLoading(loading, false);
        });
    }
  };

  const handlePcrFileChange = (e) => {
    //每次開啟選擇檔案觸發onChange事件
    if (e.target.files[0]) {
      if (e.target.files[0].size >= 20000000) {
        AlertService.ok("Error", "Size over 20MB");
        setPcrPreviewUrl(null);
        setPcrZoomSrc(null);
        setValue("pcrFileExtension", ""); //副檔名
        setValue("pcrFileName", ""); //檔名
        setValue("pcrFilePic", "");
        setPcrFileInfo({});
        pcrFileInputRef.current.value = null;
      } else {
        setPcrPreviewUrl(URL.createObjectURL(e.target.files[0]));
        setPcrZoomSrc(URL.createObjectURL(e.target.files[0]));

        let fileExtension = splitFileExtension(e.target.files[0]?.name);
        setValue("pcrFileExtension", fileExtension); //副檔名
        setValue("pcrFileName", splitFileName(e.target.files[0]?.name));
        setPcrFileInfo(e.target.files[0]);

        // 測試用 ↓
        getFileBase64(e.target.files[0]).then((result) => {
          setValue("pcrFilePathSml", result);
          setValue("pcrFilePath", result);
        });
        // 測試用 ↑

        setValue("pcrFilePic", e.target.files[0], { shouldValidate: true }); //檔案格式 原圖 如果轉為MulitPart 需解開此
      }
    }
  };

  const handleDeletePcr = () => {
    //刪除圖片
    if (pcrFileInputRef?.current?.value !== undefined) {
      pcrFileInputRef.current.value = null;
      setPcrPreviewUrl(null);
      setPcrZoomSrc(null);
      setValue("pcrFileExtension", ""); //副檔名
      setValue("pcrFfileName", ""); //檔名
      setValue("pcrFilePic", "");
    }
  };

  const axios_CoefficientUnitList = () => {
    getSubItemsByItemNo("COEFFICIENT_UNIT", 27).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setUnitCodeList(newArray);
      }
    });
    // lifeCycle Scope
    getSubItemsByItemNo("LIFE_CYCLE_SCOPE", 32).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setLifeCycleScopeList(newArray);
      }
    });
    // productType
    getSubItemsByItemNo("PRODUCT_TYPE", 31).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        let newArray = data.map((item, index) => {
          return {
            ...item,
            index: index,
          };
        });
        setProductTypeList(newArray);
      }
    });

    //pcr List
    queryPcrReportList().then((res) => {
      if (checkDpSuccess(res)) {
        let data = res?.data?.RespBody?.pcrReportList?.options;
        setPcrReportList(data);
      }
    });
  };

  return (
    <>
      {/* 返回上頁 */}
      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button
            rounded
            text
            onClick={() => {
              btnBackTo();
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t("button.return_to_list")}
          </Button>
        </div>
      </div>
      {(itemObj?.companyName ?? companyName) && (
        <div className="p-card bg-gray">
          <div className="p-card-body">
            <div className="grid">
              <div className="col-12">
                <h3 className="m-0">{itemObj?.companyName ?? companyName}</h3>
              </div>
            </div>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="p-card">
          <div className="p-card-body">
            <div className="font-semibold">{t("productInfo")}</div>
            <div className="grid">
              <div className="col-12 lg:col-6">
                {/* 中文名稱 */}
                <div className="my-4">
                  <label htmlFor="offeringsId" className="form-label">
                    {t("chzName")}
                  </label>
                  <Controller
                    name="offeringsId"
                    control={control}
                    rules={setValidForm("offeringsId")}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        filter
                        optionLabel="label"
                        optionValue="value"
                        disabled={action !== "create" || !isEditable}
                        appendTo={"self"}
                        value={field.value}
                        virtualScrollerOptions={{ itemSize: 40 }}
                        defaultValue={""}
                        placeholder={t("plz_chs")}
                        options={comProductList}
                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                        onChange={(event) => {
                          field.onChange(event.value);
                          axios_queryCompanyProductDetail({ offeringsId: event.value });
                        }}
                      />
                    )}
                  />
                </div>
                {/* 英文名稱 */}
                <div className="my-4">
                  <FormInput
                    labelClass="required"
                    withLabel={true}
                    register={register}
                    errors={errors}
                    id="productEName"
                    labelText={t("enName")}
                    type="text"
                    disabled={true}
                    enterClick={inputCheckKeyDown}
                    rules={{ required: t("validation.required") }}
                  />
                </div>
              </div>

              {/* 產品圖片 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="customFile" className="form-label">
                  {t("productPic")}
                </label>
                <div className="grid" style={{ minHeight: `${!isEditable ? "160px" : "calc(160px - 0.6rem)"}` }}>
                  {/* 檢視不能選檔案 */}
                  {/* {
                                editAction==='detail'?(<></>):(<div className={`col-12 ${previewUrl?'lg:col-6':''}`}>
                                    <FormInputFile
                                    wrapperStyle={{padding:'0.7rem'}}
                                    disabled={editAction==='detail'}
                                    register={register}
                                    errors={errors}
                                    acceptFileType=".jpg,.png"
                                    id="customFile"
                                    name="customFile"
                                    limitSize="20MB"
                                    fileChange={(e) => { handleFileChange(e) }}
                                    rules={{
                                        required: { value: false, message: t('validation.required') }
                                    }}
                                    fileInputRef={fileInputRef}
                                    />
                                </div>)
                            } */}

                  {previewUrl && (
                    <div className={`col-12 ${previewUrl ? "lg:col-6" : ""}`}>
                      <ImagePDFComponent
                        disabled={true}
                        wrapperClass=""
                        file={fileInfo}
                        previewUrl={previewUrl}
                        zoomSrc={zoomSrc}
                        imgWidth="150"
                        imgHeight="150"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* 產品流程圖 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="customFile" className="form-label">
                  {t("productFlowPic")}
                </label>
                <div className="grid" style={{ minHeight: `${!isEditable ? "160px" : "calc(160px - 0.6rem)"}` }}>
                  {/* 檢視不能選檔案 */}
                  {/* {
                                editAction==='detail'?(<></>):(<div className={`col-12 ${previewUrl?'lg:col-6':''}`}>
                                    <FormInputFile
                                    wrapperStyle={{padding:'0.7rem'}}
                                    disabled={editAction==='detail'}
                                    register={register}
                                    errors={errors}
                                    acceptFileType=".jpg,.png"
                                    id="customFile"
                                    name="customFile"
                                    limitSize="20MB"
                                    fileChange={(e) => { handleFileChange(e) }}
                                    rules={{
                                        required: { value: false, message: t('validation.required') }
                                    }}
                                    fileInputRef={fileInputRef}
                                    />
                                </div>)
                            } */}

                  {flowPreviewUrl && (
                    <div className={`col-12 ${flowPreviewUrl ? "lg:col-6" : ""}`}>
                      <ImagePDFComponent
                        disabled={true}
                        wrapperClass=""
                        file={flowFileInfo}
                        previewUrl={flowPreviewUrl}
                        zoomSrc={flowZoomSrc}
                        imgWidth="150"
                        imgHeight="150"
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* 產品類型 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="placeName" className="form-label required">
                  {t("productType")}
                </label>
                <Controller
                  name="productType"
                  control={control}
                  rules={{ required: { value: true, message: t("validation.required") } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      disabled={true}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="productType"
                      control={control}
                      options={productTypeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* 每單位數量 */}
              {/* <div className="col-12 lg:col-3">
                    <FormInput
                            labelClass="required"
                            withLabel={true}
                            register={register}
                            errors={errors}
                            id="quantity"
                            labelText={`每單位數量`}
                            type="number"
                            disabled={editAction==='detail'}
                            enterClick={inputCheckKeyDown}     
                            rules={{required: t('validation.required'),}}
                        />
                </div> */}
              {/* 宣告單位 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="declaringUnit" className="form-label required">
                  {t("declareUnit")}
                </label>
                <Controller
                  name="declaringUnit"
                  control={control}
                  rules={{ required: { value: true, message: t("validation.required") } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      disabled={true}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="unitCode"
                      control={control}
                      options={unitCodeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>

              {/* 功能單位 */}
              <div className="col-12 lg:col-4">
                <label htmlFor="functionalUnit" className="form-label">
                  {t("functionalUnit")}
                </label>
                <Controller
                  name="functionalUnit"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      disabled={true}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="unitCode"
                      control={control}
                      options={unitCodeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>

              {/* 盤查總產量 */}
              <div className="col-12 lg:col-4">
                <FormNumberInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="quantity"
                  // labelText={t("totalDeclaredProd")}
                  labelText={
                    (() => {
                      const declaringUnit = watch("declaringUnit");
                      const unitItem = unitCodeList?.find((item) => item.subitemNo === declaringUnit);
                      const unitName = unitItem?.subitemName || "";
                      return unitName ? `${t("totalDeclaredProd")}(${unitName})` : t("totalDeclaredProd");
                    })()
                  }
                  step="any"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("quantity")}
                  value={watch("quantity")}
                  onChange={(newValue) => setValue("quantity", newValue)}
                />
              </div>

              {/* 場域選擇 */}
              <div className="col-12 lg:col-8">
                <label htmlFor="placesList" className="form-label required">
                  {t("place")}
                </label>
                <div className="flex gap-2">
                  <div className="flex-grow-1">
                    <Controller
                      name="placesList"
                      control={control}
                      rules={setValidForm("placeSeq")}
                      render={({ field, fieldState }) => (
                        <MultiSelect
                          filter
                          showClear
                          className="w-full"
                          disabled={action === "detail"}
                          style={{ width: "100%" }}
                          display="chip"
                          options={placesList}
                          optionLabel={"placeName"}
                          optionValue={"placeSeq"}
                          maxSelectedLabels={3}
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.value);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
                {getFormErrorMessage(errors, "placesList")}
              </div>

              {/* PCR select */}
              <div className="col-12 lg:col-4">
                <label htmlFor="pcrReportId" className="form-label">
                  {t("applicablePCR")}
                </label>
                <Controller
                  name="pcrReportId"
                  control={control}
                  rules={setValidForm("pcrReportId")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      showClear
                      optionLabel="label"
                      optionValue="value"
                      disabled={action === "detail" || !isEditable}
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="pcrReportId"
                      control={control}
                      options={pcrReportList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>
              {/* PCR 上傳區 */}
              <div className="col-12 lg:col-8">
                <label htmlFor="pcrReportId" className="form-label">
                  {t("uploadPCR")}
                </label>
                <div className="grid" style={{ minHeight: `${!isEditable ? "160px" : "calc(160px - 0.6rem)"}` }}>
                  {/* 檢視不能選檔案 */}
                  {action !== "detail" && isEditable && (
                    <div className={`col-12 ${pcrPreviewUrl ? "lg:col-8" : ""}`}>
                      <FormInputFile
                        wrapperStyle={{ padding: "0.7rem" }}
                        disabled={action === "detail" || !isEditable}
                        register={register}
                        errors={errors}
                        acceptFileType=".pdf"
                        id="pcrFilePic"
                        name="pcrFilePic"
                        limitSize="20MB"
                        fileChange={(e) => {
                          handlePcrFileChange(e);
                        }}
                        rules={{
                          required: { value: false, message: t("validation.required") },
                        }}
                        fileInputRef={pcrFileInputRef}
                      />
                    </div>
                  )}

                  {pcrPreviewUrl && (
                    <div className={`col-12 ${action !== "detail" && isEditable ? "lg:col-4" : "lg:col-12"}`}>
                      <ImagePDFComponent
                        disabled={action === "detail" || !isEditable}
                        wrapperClass=""
                        file={pcrFileInfo}
                        previewUrl={pcrPreviewUrl}
                        deleteImg={(e) => {
                          handleDeletePcr(e);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* 生命週期範疇 */}
              <div className="col-12 lg:col-3">
                <label htmlFor="lifeCycleScope" className="form-label required">
                  {t("life_cycle_scope")}
                </label>
                <Controller
                  name="lifeCycleScope"
                  control={control}
                  rules={setValidForm("lifeCycleScope")}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      filter
                      showClear
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      disabled={action === "detail" || !isEditable}
                      appendTo={"self"}
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="lifeCycleScope"
                      control={control}
                      options={lifeCycleScopeList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                      }}
                    />
                  )}
                />
              </div>

              {/* 單件重量 (kg) */}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="unitWeightKg"
                  labelText={t("unitWeightkg")}
                  step="any"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("unitWeightKg")}
                  value={watch("unitWeightKg")}
                  onChange={(newValue) => setValue("unitWeightKg", newValue)}
                />
              </div>

              {/* 產品比例 */}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="productRatio"
                  labelText={`${t("productRatio")}(%)`}
                  step="any"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("productRatio")}
                  value={watch("productRatio")}
                  onChange={(newValue) => setValue("productRatio", newValue)}
                />
              </div>

              {/* 分配比列計算依據 */}
              <div className="col-12 lg:col-3">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="productRatioComment"
                  labelText={t("allocationBasis")}
                  type="text"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("productRatioComment")}
                />
              </div>

              {/* 技術描述 */}
              <div className="col-12">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="technicalDescription"
                  name="technicalDescription"
                  type="text"
                  labelText={t("technicalDes")}
                  areaClass="w-full"
                  disabled={true}
                />
              </div>
              {/* 分配原則 */}
              {/* <div className="col-12">
                    <FormTextarea
                        labelClass='required'
                        register={register}
                        errors={errors}
                        id="distributionPrinciple"
                        name="distributionPrinciple"
                        type="text"
                        labelText={t('allocationPrinciples')}
                        areaClass="w-full"
                        disabled={action === 'detail' || !isEditable}
                        rules={setValidForm("distributionPrinciple")}
                    />
                </div> */}
              {/* 排除項目 */}
              <div className="col-12">
                <FormTextarea
                  disabled={action === "detail" || !isEditable}
                  labelClass="required"
                  register={register}
                  errors={errors}
                  id="excludedItems"
                  name="excludedItems"
                  type="text"
                  labelText={t("exclusions")}
                  areaClass="w-full"
                  rules={setValidForm("excludedItems")}
                />
              </div>
              {/* 盤查日期起迄 */}
              <div className="col-12 lg:col-6">
                <label htmlFor="inspectionStartDate" className="form-label required">
                  {t("startYear_endYear_roc")}
                </label>
                <div className="col-date-picker">
                  <Controller
                    name="inspectionStartDate"
                    control={control}
                    rules={{
                      required: { value: true, message: t("validation.required") },
                      validate: (val) => {
                        if (val !== "" && watch("inspectionEndDate") !== "" && watch("inspectionEndDate") < val)
                          return t("validation.startDate");
                      },
                    }}
                    render={({ field, fieldState, formState }) => (
                      <Calendar
                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                        dateFormat="yy-mm-dd"
                        disabled={action === "detail" || !isEditable}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.value);
                          if (e.value < watch("inspectionEndDate")) {
                            clearErrors("inspectionEndDate");
                          }
                        }}
                        showIcon
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "inspectionStartDate")}

                  <Controller
                    name="inspectionEndDate"
                    control={control}
                    rules={{
                      required: { value: true, message: t("validation.required") },
                      validate: (val) => {
                        if (val !== "" && watch("inspectionStartDate") !== "" && watch("inspectionStartDate") > val)
                          return t("validation.endDate");
                      },
                    }}
                    render={({ field, fieldState, formState }) => (
                      <Calendar
                        className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                        dateFormat="yy-mm-dd"
                        disabled={action === "detail" || !isEditable}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.value);
                          if (e.value > watch("inspectionStartDate")) {
                            clearErrors("inspectionStartDate");
                          }
                        }}
                        showIcon
                      />
                    )}
                  />
                  {getFormErrorMessage(errors, "inspectionEndDate")}
                </div>
              </div>

              {/*排放係數來源  */}
              <div className="col-12 lg:col-3">
                <FormInput
                  labelClass="required"
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="coefSource"
                  labelText={t("emissionCoefficientSources")}
                  type="text"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("coefSource")}
                />
              </div>
              {/* 備註說明 */}
              <div className="col-12">
                <FormTextarea
                  labelClass=""
                  register={register}
                  errors={errors}
                  id="comment"
                  name="comment"
                  type="text"
                  labelText={t("remarkDesc")}
                  areaClass="w-full"
                  disabled={action === "detail" || !isEditable}
                  rules={setValidForm("comment")}
                />
              </div>

              <div className="col-12">
                <label className="font-semibold">{t("productIntro")}</label>({t("productIntroHint")})
              </div>

              <div className="col-12">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="productIntroduction"
                  name="productIntroduction"
                  type="text"
                  labelText={t("productIntroduction")}
                  areaClass="w-full"
                  disabled={true}
                />
              </div>

              <div className="col-12">
                <label className="font-semibold">{t("sensitivity")}</label>
              </div>

              {/* 敏感度分析變動百分比 */}
              <div className="col-12 lg:col-3">
                <FormNumberInput
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="sensitivityDeltaPct"
                  labelText={t("sensitivity_delta_pct")}
                  labelClass={`control-label required`}
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                  rules={setValidForm("sensitivityDeltaPct")}
                  value={watch("sensitivityDeltaPct")}
                  onChange={(newValue) => setValue("sensitivityDeltaPct", newValue)}
                />
              </div>

              {/* 敏感度分析原因說明 */}
              <div className="col-12 lg:col-9">
                <FormTextarea
                  register={register}
                  errors={errors}
                  id="sensitivityReason"
                  name="sensitivityReason"
                  type="text"
                  labelText={t("sensitivity_reason")}
                  labelClass="w-full required"
                  disabled={action === "detail" || !isEditable}
                  rules={setValidForm("sensitivityReason")}
                />
              </div>

              <div className="col-12">
                <label className="font-semibold">{t("managementInf")}</label>
              </div>

              {/* 委託單位 */}
              <div className="col-12 lg:col-3">
                <FormInput
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="implementingOrganization"
                  labelText={t("implementingOrgaName")}
                  type="text"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                />
              </div>
              <div className="col-12 lg:col-3">
                <FormInput
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="consultingAgencyName"
                  labelText={t("consultingAgencyName")}
                  type="text"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                />
              </div>

              <div className="col-12 lg:col-3">
                <Controller
                  name="verified"
                  control={control}
                  render={({ field, fieldState }) => (
                    <>
                      <Checkbox
                        disabled={action === "detail" || !isEditable}
                        inputId={field.name}
                        checked={field.value}
                        inputRef={field.ref}
                        className={classNames({ "p-invalid": fieldState.error })}
                        onChange={(e) => {
                          field.onChange(e.checked);
                          if (e.checked) {
                            clearErrors(["verificationAgency"]);
                          }
                        }}
                      />
                      <label htmlFor={field.name} className="ml-2">
                        {t("verifiedByThirdParty")}
                      </label>
                    </>
                  )}
                />
              </div>
              {/* 查驗證公司 */}
              <div className="col-12 lg:col-3">
                <FormInput
                  withLabel={true}
                  register={register}
                  errors={errors}
                  id="verificationAgency"
                  labelText={t("verificationCompany")}
                  type="text"
                  disabled={action === "detail" || !isEditable}
                  enterClick={inputCheckKeyDown}
                />
              </div>
            </div>

            {action === "create" ? (
              <div className="col-12 gap-2 flex-all-center">
                <Button disabled={!(isValid && isDirty)} type="submit" label={t("button.confirm")} size="small" />
                <Button
                  outlined
                  size="small"
                  type="button"
                  label={t("button.cancel")}
                  onClick={(e) => {
                    e.preventDefault();
                    btnBackTo();
                  }}
                />
              </div>
            ) : (
              <>
                {action === "detail" ? (
                  <div className="col-12 gap-2 flex-all-center">
                    <Button
                      label={t("button.edit")}
                      onClick={(e) => {
                        e.preventDefault();
                        setAction("update");
                      }}
                      type="button"
                      size="small"
                      disabled={!isEditable}
                    />
                  </div>
                ) : (
                  <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                    <Button
                      outlined
                      size="small"
                      type="button"
                      label={t("button.cancel")}
                      onClick={(e) => {
                        e.preventDefault();
                        setAction("detail");
                        btnBackTo();
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </form>
    </>
  );
};

export default InventoryCarbonFootprintCreate;
